import { render, staticRenderFns } from "./devServiceProvideList.vue?vue&type=template&id=7482ed20&scoped=true"
import script from "./devServiceProvideList.vue?vue&type=script&lang=js"
export * from "./devServiceProvideList.vue?vue&type=script&lang=js"
import style0 from "./devServiceProvideList.vue?vue&type=style&index=0&id=7482ed20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7482ed20",
  null
  
)

export default component.exports